// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cd2N","col":"styles_col__G19Gl"};